import { FormLabel, Typography, TextField } from "@mui/material";
import { inputStateUpdate } from "../utility";
import { useEffect, useState } from "react";
import { FormErrorType } from "./BasicTextField";
import useFormStyles from "../../../styles/useFormStyles";
import { useTheme } from "@mui/material/styles";

export type DateFieldProps = {
  label?: string;
  stateKey: string;
  setState: Function;
  disableSubmit: Function;
  defaultValue: string;
  clear?: boolean;
  maxValue?: string;
  required?: boolean;
  readonly?: boolean;
  futureDate?: boolean;
  minDate?: string;
  errorMessage?: string;
};

const DateField: React.FC<DateFieldProps> = (props: DateFieldProps) => {
  const {
    label,
    stateKey,
    setState,
    disableSubmit,
    defaultValue,
    clear,
    maxValue,
    readonly,
    futureDate = false,
    minDate,
    required = false,
    errorMessage,
  } = props;
  const formStyles = useFormStyles();
  const [visited, setVisited] = useState<boolean>(false);
  const [date, setDate] = useState<string>(defaultValue);
  const [error, setError] = useState<FormErrorType>({
    error: false,
    message: "",
  });

  const changeHandler = (e: React.SyntheticEvent) => {
    setDate((e.target as HTMLInputElement).value);
  };

  const theme = useTheme();
  const readOnlyStyles: React.CSSProperties = {
    backgroundColor: theme.color?.readOnly,
  };

  const validate = (inputDate: Date | string) => {
    setError((prev: FormErrorType) => {
      return {
        ...prev,
        error: false,
        message: "",
      };
    });
    const _date = new Date();
    const selectedDate = new Date(inputDate);
    if (
      !(
        selectedDate instanceof Date &&
        _date.getFullYear() - selectedDate!.getFullYear() >= 18
      ) &&
      visited
    ) {
      disableSubmit(true);
      if (stateKey === "dob_date") {
        setError((prev: FormErrorType) => {
          return {
            ...prev,
            error: true,
            message: "User must be at least 18 years of age",
          };
        });
      }
      // else if (
      //   stateKey === "expiryDate" &&
      //   minDate &&
      //   new Date(minDate) >= new Date(inputDate)
      // ) {
      //   setError((prev: FormErrorType) => {
      //     return {
      //       ...prev,
      //       error: true,
      //       message: "Give valid expiry date",
      //     };
      //   });
      // }
      else if (
        stateKey === "issueDate" &&
        minDate &&
        new Date(minDate) < new Date(inputDate)
      ) {
        setError((prev: FormErrorType) => {
          return {
            ...prev,
            error: true,
            message: "Give valid issue date",
          };
        });
      }
    } else if (inputDate?.toString() === "") {
      disableSubmit(true);
      setError((prev: FormErrorType) => {
        return {
          ...prev,
          error: true,
          message: "required field",
        };
      });
    } else {
      disableSubmit(false);
      setError((prev: FormErrorType) => {
        return { ...prev, error: false };
      });
    }
  };

  useEffect(() => {
    if (visited) {
      validate(date);
      inputStateUpdate(stateKey, setState, "", () => {
        return date ? new Date(date) : null;
      });
    }
    if (clear) {
      setVisited(false);
      setDate("");
    }
  }, [date, visited, clear]);

  return (
    <>
      {label ? (
        <FormLabel sx={{ ...formStyles.formLabel, color: "#252836" }}>
          {label}{" "}
        </FormLabel>
      ) : null}
      <TextField
        required={required}
        onError={() => {
          validate(date);
        }}
        onFocus={() => {
          setVisited(true);
        }}
        style={readonly ? readOnlyStyles : {}}
        value={date}
        size="small"
        type="date"
        onChange={changeHandler}
        error={error.error}
        InputProps={{
          placeholder: "",
          inputProps: !futureDate
            ? {
                max: maxValue
                  ? maxValue
                  : new Date().toISOString().split("T")[0],
              }
            : {},
          readOnly: readonly ? readonly : false,
        }}
        helperText={
          (errorMessage || (error.error && error.message)) && (
            <Typography
              component={"span"}
              textAlign={"left"}
              color={"error"}
              fontSize={"0.7rem"}
              sx={{ mx: 2, mt: 0.5, position: "absolute", top: "100%" }}
              mt={0}
            >
              {errorMessage || error.message}
            </Typography>
          )
        }
      />
    </>
  );
};

export default DateField;
